import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";

// Tu configuración web de Firebase.
// Estas variables deben venir de tu fichero .env.local para desarrollo local,
// y desde las variables de entorno (Environment Variables) en Netlify para producción.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

/**
 * Log an analytics event to the Firestore "analytics" collection.
 * @param {"login"|"visit"|"image_view"} type - The event type.
 * @param {string} category - Grouping key (userName for logins, page path for visits, "project-index" for images).
 * @param {string} userName - The user who triggered the event.
 * @param {object} metadata - Optional extra data (e.g. { url: "/home" })
 */
export const logAnalyticsEvent = async (type, category, userId, metadata = {}) => {
    try {
        await addDoc(collection(db, "analytics"), {
            type,
            category,
            userName: userId || 'Anonymous', // Keeping field name 'userName' for compatibility but filling it with userId
            timestamp: serverTimestamp(),
            date: Date.now(),
            ...metadata
        });
    } catch (err) {
        console.error("Analytics event error:", err);
    }
};
